import {AcademyMedia} from '../../../../models/academy-media.model';
import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {TranslationService} from 'app/services/translation.service';
import {DateMomentService} from 'app/services/date-moment.service';
import {environment} from '../../../../../environments/environment';
import {EmitterService} from 'app/services/emitter.service';
import {MediaService} from 'app/services/media.service';
import {AuthService} from '../../../../services/auth.service';
import {User} from '../../../../models/user.model';
import {LocaleService} from '../../../../services/locale.service';
import {UserService} from "../../../../services/user.service";


@Component({
    selector: 'contributions-videos',
    templateUrl: './videos.component.html',
    styleUrls: ['./videos.component.scss'],
    providers: [
        MediaService
    ]
})
export class ContributionsVideosComponent implements OnInit {
    locale: string;
    videosPublished: AcademyMedia[] = [];
    environment: any = environment;
    contributionsVideosPublishedEmitter = 'contributionsVideosPublishedEmitter';
    contributionsVideosPublished10MoreEmitter = 'contributionsVideosPublished10MoreEmitter';
    videos: any;
    user: User;
    loading: boolean = false;
    noResults:boolean = false;

    constructor(private activatedRoute: ActivatedRoute,
                public translationService: TranslationService,
                public dateMomentService: DateMomentService,
                public localeService: LocaleService,
                private mediaService: MediaService,
                private userService: UserService,
                private authService: AuthService) {
    }

    ngOnInit() {
        this.loading = true;
        this.locale = this.localeService.currentLocale();
        this.user = this.authService.getCurrentUser();
        this.getUserVideos();

        EmitterService
            .get(this.contributionsVideosPublishedEmitter)
            .subscribe((result) => {
                this.loading = false;
                if (!result.error) {
                    result.forEach(el => {
                        this.videosPublished.push(new AcademyMedia(el));
                    })
                }
            });
    }

  getUserVideos() {
    this.user = this.authService.getCurrentUser();
    if (this.user.id) {
      this.userService.getUser(this.user.id, {account: 1}).subscribe(
        user => {
          this.user = new User({...this.user, ...user});
          if(user.media_ids && user.media_ids.video_published.length > 0) {
            user.media_ids.video_published.forEach((media,index) => {
              this.mediaService.getMedia(media).subscribe(test=>{
                this.videosPublished.push(new AcademyMedia(test));
              });
              if(index === user.media_ids.video_published.length -1) {
                  this.loading = false;
              }
            })
          } else {
            this.loading = false;
            this.noResults = true;

          }
        }
      );
    }

  }
}
